export default __webpack_public_path__ + "static/media/info-circle-solid.16d18470.svg";